/** @format */
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ModuleContentWorkflowDecision } from 'common-typescript/types';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { STUDENT_WORKFLOW_DECISION_STATE } from '../../model/student-workflow-constants';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-module-content-workflow-decision',
    templateUrl: './module-content-workflow-decision.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModuleContentWorkflowDecisionComponent {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.applications.moduleContentWorkflowDecision.downgraded',
        directiveName: 'sisModuleContentWorkflowDecision',
    };

    readonly workflowDecisionState = STUDENT_WORKFLOW_DECISION_STATE;

    @Input() moduleContentWorkflowType: 'CustomModuleContentWorkflow' | 'RequiredModuleContentWorkflow';
    @Input() moduleContentWorkflowDecision: ModuleContentWorkflowDecision;
}
